/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Not_SetInputs */

const en_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set`)
};

const fr_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non défini`)
};

const de_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht festgelegt`)
};

const it_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non impostato`)
};

const ru_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не задано`)
};

const es_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No establecido`)
};

const zh_cn2_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未设置`)
};

const ja_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定されていません`)
};

const hi_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेट नहीं`)
};

const pt_pt2_compare_event_groups_not_set = /** @type {(inputs: Compare_Event_Groups_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não definido`)
};

/**
* | output |
* | --- |
* | "Not set" |
*
* @param {Compare_Event_Groups_Not_SetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_not_set = /** @type {((inputs?: Compare_Event_Groups_Not_SetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Not_SetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_not_set(inputs)
	if (locale === "de") return de_compare_event_groups_not_set(inputs)
	if (locale === "it") return it_compare_event_groups_not_set(inputs)
	if (locale === "ru") return ru_compare_event_groups_not_set(inputs)
	if (locale === "es") return es_compare_event_groups_not_set(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_not_set(inputs)
	if (locale === "ja") return ja_compare_event_groups_not_set(inputs)
	if (locale === "hi") return hi_compare_event_groups_not_set(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_not_set(inputs)
	return en_compare_event_groups_not_set(inputs)
});